/* eslint-disable react/prop-types */
import React, { useState } from "react";
import axios from "axios";
import { Col, Row, Form, Button } from "react-bootstrap";

const AddAdhoc = (props) => {
  const parentID = props.parentID;
  const type = props.type;
  const [participantName, setParticipantName] = useState("");

  const handleAdhoc = async (e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
    const adhocRequest = await axios.post(
      `/api/admin/registers/create_adhoc/${type}`,
      {
        parentID,
        participantName,
      },
      {
        withCredentials: true,
      }
    );
    if (adhocRequest.status === 200) {
      props.fetchNewData();
      props.setSuccessMessage("Adhoc participant added.");
      window.scrollTo(10, 0);
      return props.setSubmitClicked(false);
    } else {
      props.setSubmitClicked(false);
      window.scrollTo(10, 0);
      return props.setErrorMessage("There was a problem with that request.");
    }
  };
  return (
    <Row className='mt-3 mb-3 shadow-element text-center pt-3 pb-3'>
      <Col>
        <h3 className='mt-3 mb-3'>Add Adhoc Participant</h3>
        <Form className='Register' onSubmit={handleAdhoc}>
          <Row>
            <Col lg='10'>
              <Form.Group controlId='Register'>
                <Form.Control
                  type='text'
                  maxLength='56'
                  placeholder='Full Name'
                  value={participantName}
                  onChange={(e) => setParticipantName(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col lg='2'>
              <Button variant='success' className='btn btn-default btn-success' type='submit'>
                Add Participant
              </Button>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

export default AddAdhoc;
